function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import AwsS3Multipart from '@uppy/aws-s3-multipart';
import { Uppy } from '@uppy/core';
import { DragDrop, useUppy } from '@uppy/react';
import classNames from 'classnames';
import { Form, Formik } from 'formik';
import React, { useState, useCallback, useRef } from 'react';
import { useMount } from 'react-use';
import text from '../../../text';
import { getUser } from '../../../utilities/storage';
import { Button } from '../../button';
import ReactCrop from 'react-image-crop';
import 'react-image-crop/dist/ReactCrop.css';
import Icon from '../../icon/Icon';
import { useDispatch } from 'react-redux';
import { alertError } from '../../../redux/actions';
import { centerAspectCrop, COMPANY_LOGO_HEIGHT, COMPANY_LOGO_WIDTH, createCroppedImage } from './utils';
import { v4 as uuidv4 } from 'uuid';
import { useUpdateCompanyLogoMutation } from '../../../redux/rtk';
var validTypes = [
    'image/jpeg',
    'image/jpg',
    'image/png',
    'image/webp'
];
var SelectImageForm = function(param) {
    var onSubmit = param.onSubmit, onCancel = param.onCancel;
    var dispatch = useDispatch();
    var aspect = COMPANY_LOGO_WIDTH / COMPANY_LOGO_HEIGHT;
    var imgRef = useRef(null);
    // State for cropper
    var _useState = _sliced_to_array(useState(), 2), crop = _useState[0], setCrop = _useState[1];
    var _useState1 = _sliced_to_array(useState(1), 2), scale = _useState1[0], setScale = _useState1[1];
    var _useState2 = _sliced_to_array(useState(null), 2), imageSrc = _useState2[0], setImageSrc = _useState2[1];
    var _useState3 = _sliced_to_array(useState(null), 2), croppedAreaPixels = _useState3[0], setCroppedAreaPixels = _useState3[1];
    var _useState4 = _sliced_to_array(useState(null), 2), selectedFileId = _useState4[0], setSelectedFileId = _useState4[1];
    var _useState5 = _sliced_to_array(useState(false), 2), showCropper = _useState5[0], setShowCropper = _useState5[1];
    var _useState6 = _sliced_to_array(useState(null), 2), error = _useState6[0], setError = _useState6[1];
    var _useState7 = _sliced_to_array(useState(false), 2), uploading = _useState7[0], setUploading = _useState7[1];
    // Define slider min/max values so that 0.5 is in the middle
    var sliderMinScale = 0.25;
    var sliderMaxScale = 0.75;
    var _useUpdateCompanyLogoMutation = _sliced_to_array(useUpdateCompanyLogoMutation(), 1), updateCompanyLogo = _useUpdateCompanyLogoMutation[0];
    var onCropComplete = useCallback(function(pixelCrop) {
        setCroppedAreaPixels(pixelCrop);
    }, []);
    var onImageLoad = function(e) {
        if (aspect) {
            var _e_currentTarget = e.currentTarget, width = _e_currentTarget.width, height = _e_currentTarget.height;
            var newCrop = centerAspectCrop(width, height, aspect);
            setCrop(newCrop);
            // Fixed initial scale at 0.5 as requested
            setScale(0.5);
        }
    };
    var uppy = useUppy(function() {
        var newUppy = new Uppy({
            debug: process.env.NODE_ENV === 'development',
            autoProceed: false,
            restrictions: {
                allowedFileTypes: [
                    '.jpg',
                    '.jpeg',
                    '.png',
                    '.webp'
                ].concat(_to_consumable_array(validTypes)),
                maxNumberOfFiles: 1
            }
        }).use(AwsS3Multipart, {
            limit: 1,
            companionUrl: "".concat(process.env.UPPY_COMPANION_URL, "/company-logo"),
            companionHeaders: {
                Authorization: "Bearer ".concat(getUser().token)
            }
        });
        newUppy.on('restriction-failed', function() {
            setError(text('allowedImageFileTypes'));
        }).on('file-added', function(file) {
            if (!file.type || !validTypes.includes(file.type)) {
                uppy.removeFile(file.id);
                setError(text('allowedImageFileTypes'));
                return;
            }
            // Create a preview URL for the selected image
            var data = file.data;
            if (data && data.type.startsWith('image/')) {
                var reader = new FileReader();
                reader.addEventListener('load', function() {
                    setImageSrc(reader.result);
                    setSelectedFileId(file.id);
                    setShowCropper(true);
                });
                try {
                    reader.readAsDataURL(data);
                } catch (error) {
                    console.error("".concat(text('errorReadingSelectedImage'), ":"), error);
                    dispatch(alertError(text('errorReadingSelectedImage')));
                }
            }
            uppy.setFileMeta(file.id, {
                filePath: "images/company-logo/".concat(uuidv4())
            });
        }).on('upload', function() {
            setUploading(true);
            setError(null);
        }).on('error', function(error) {
            setUploading(false);
            setError(error === null || error === void 0 ? void 0 : error.message);
        }).on('upload-error', function(_, error) {
            setUploading(false);
            setError(error === null || error === void 0 ? void 0 : error.message);
            newUppy.reset();
        });
        return newUppy;
    });
    useMount(function() {
        return function() {
            uppy.cancelAll();
        };
    });
    var onHandleCancel = function(event) {
        event.preventDefault();
        uppy.cancelAll();
        setImageSrc(null);
        setShowCropper(false);
        onCancel();
    };
    var onHandleSubmit = /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function() {
            var blob, originalFile, fileType, supportsTransparency, fileExtension, fileName, error;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            3,
                            ,
                            4
                        ]);
                        if (!(imageSrc && croppedAreaPixels && selectedFileId && imgRef.current)) return [
                            3,
                            2
                        ];
                        setUploading(true);
                        return [
                            4,
                            createCroppedImage(imgRef.current, croppedAreaPixels, scale)
                        ];
                    case 1:
                        blob = _state.sent().blob;
                        originalFile = uppy.getFile(selectedFileId);
                        // check if supports transparency
                        fileType = originalFile.type;
                        supportsTransparency = fileType === 'image/png' || fileType === 'image/webp';
                        fileExtension = originalFile.name.split('.').pop();
                        if (!fileExtension || ![
                            'jpg',
                            'jpeg',
                            'png',
                            'webp'
                        ].includes(fileExtension.toLowerCase())) {
                            fileExtension = supportsTransparency ? fileType === 'image/webp' ? 'webp' : 'png' : 'jpg';
                        }
                        fileName = "cropped-".concat(new Date().getTime(), ".").concat(fileExtension);
                        uppy.setFileState(selectedFileId, {
                            data: blob,
                            name: fileName,
                            type: fileType
                        });
                        uppy.upload().then(/*#__PURE__*/ function() {
                            var _ref = _async_to_generator(function(result) {
                                var uploadedFile;
                                return _ts_generator(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            if (!(result.successful.length > 0)) return [
                                                3,
                                                2
                                            ];
                                            uploadedFile = result.successful[0];
                                            if (!uploadedFile.meta.filePath) return [
                                                3,
                                                2
                                            ];
                                            return [
                                                4,
                                                updateCompanyLogo({
                                                    filePath: "".concat(uploadedFile.meta.filePath, "/").concat(uploadedFile.name)
                                                }).unwrap()
                                            ];
                                        case 1:
                                            _state.sent();
                                            onSubmit();
                                            _state.label = 2;
                                        case 2:
                                            return [
                                                2
                                            ];
                                    }
                                });
                            });
                            return function(result) {
                                return _ref.apply(this, arguments);
                            };
                        }()).catch(function(error) {
                            console.error("".concat(text('errorUploadingImage'), ":"), error);
                            dispatch(alertError(text('errorUploadingImage')));
                        });
                        _state.label = 2;
                    case 2:
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        console.error("".concat(text('errorCroppingImage'), ":"), error);
                        dispatch(alertError(text('errorCroppingImage')));
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function onHandleSubmit() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ React.createElement(Formik, {
        initialValues: {},
        onSubmit: onHandleSubmit
    }, function() {
        return /* @ts-expect-error - Form component expects different props */ /*#__PURE__*/ React.createElement(Form, {
            noValidate: true
        }, !showCropper ? /*#__PURE__*/ React.createElement("div", {
            className: classNames('image-cropper mt-4', {
                disabled: uploading,
                error: error
            })
        }, /*#__PURE__*/ React.createElement(DragDrop, {
            uppy: uppy,
            note: text('dropFilesToUpload'),
            locale: {
                strings: {
                    dropHereOr: text('dropHereOr'),
                    browse: text('browseToUpload')
                }
            }
        }), error ? /*#__PURE__*/ React.createElement("p", {
            className: "Control-Feedback isFailed"
        }, error) : null) : /*#__PURE__*/ React.createElement("div", {
            className: "crop-container mt-4"
        }, imageSrc ? /*#__PURE__*/ React.createElement("div", {
            className: "d-flex justify-content-center flex-row flex-fill crop-wrapper"
        }, /*#__PURE__*/ React.createElement(ReactCrop, {
            locked: true,
            crop: crop,
            aspect: aspect,
            onChange: function(crop) {
                return setCrop(crop);
            },
            onComplete: function(crop) {
                return onCropComplete(crop);
            }
        }, /*#__PURE__*/ React.createElement("img", {
            ref: imgRef,
            src: imageSrc,
            onLoad: onImageLoad,
            style: {
                transform: "scale(".concat(scale, ")"),
                transformOrigin: 'center',
                maxWidth: '100%',
                maxHeight: '100%',
                display: 'block',
                margin: 'auto'
            }
        }))) : /*#__PURE__*/ React.createElement("div", null, "No image selected"), /*#__PURE__*/ React.createElement("div", {
            className: "crop-controls d-flex flex-row align-items-center flex-fill position-relative"
        }, /*#__PURE__*/ React.createElement("label", {
            className: "font-14 position-absolute mb-4"
        }, text('resize')), /*#__PURE__*/ React.createElement(Icon, {
            icon: "mdi_image-outline",
            className: "original size-16"
        }), /*#__PURE__*/ React.createElement("div", {
            className: "px-2 d-flex flex-fill"
        }, /*#__PURE__*/ React.createElement("input", {
            type: "range",
            value: scale,
            min: sliderMinScale,
            max: sliderMaxScale,
            step: 0.01,
            "aria-labelledby": "Zoom",
            onChange: function(e) {
                return setScale(parseFloat(e.target.value));
            },
            className: "zoom-range w-100"
        })), /*#__PURE__*/ React.createElement(Icon, {
            icon: "mdi_image-outline",
            className: "original"
        }))), /*#__PURE__*/ React.createElement("div", {
            className: "form-footer px-4"
        }, /*#__PURE__*/ React.createElement(Button, {
            disabled: !croppedAreaPixels,
            type: "submit",
            loading: uploading
        }, text('upload')), /*#__PURE__*/ React.createElement("a", {
            id: "cancel",
            href: "#",
            onClick: onHandleCancel
        }, text('cancel'))));
    });
};
export default SelectImageForm;
